var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"certificateView"},[_vm._m(0),_c('div',{staticStyle:{"width":"100%"}},[_c('news',{staticClass:"banner"})],1),_c('div',{staticStyle:{"padding-bottom":"20px"}},[_c('academy')],1)])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticStyle:{"width":"100%"}},[_c('img',{attrs:{"src":require("@/assets/img/TechnicalCollege/116.png"),"alt":""}})])
}]

export { render, staticRenderFns }